import {useEffect, useRef, useState} from 'react'
import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock'

import useNavCollapsed from 'hooks/helpers/useNavCollapsed'

import {Wrapper} from './Navigation.styles'
import TopNavigation from './TopNavigation'
import MobNav from './MobileNavigation'

const Navigation = ({...rest}) => {
  const [opened, setOpen] = useState(false)
  const navRef = useRef(null)
  const {isCollapsedUp: isCollapsed} = useNavCollapsed('tabletL')

  useEffect(() => {
    if (opened) {
      if (isCollapsed) {
        setOpen(false)
        enableBodyScroll(navRef.current)
      } else {
        disableBodyScroll(navRef.current)
      }
    } else {
      enableBodyScroll(navRef.current)
    }
  }, [opened, isCollapsed])

  // release overflow hidden on unmount
  useEffect(
    () => () => {
      navRef.current && enableBodyScroll(navRef.current)
    },
    [navRef],
  )

  return (
    <Wrapper ref={navRef} {...rest}>
      <TopNavigation opened={opened} toggleNav={() => setOpen(!opened)} />
      <MobNav opened={opened} onClose={() => setOpen(false)} />
    </Wrapper>
  )
}

export default Navigation
